const navLinks = [
  { href: "#categories", label: "题材分类" },
  { href: "#daily", label: "每日更新" },
  { href: "#featured", label: "精选作品" },
  { href: "#ongoing", label: "甜宠连载" },
  { href: "#guide", label: "追更指南" },
  { href: "#faq", label: "常见问题" },
];

const topicLinks = ["萌系漫画", "少女漫画", "甜宠漫画", "治愈漫画", "校园恋爱", "轻松搞笑"];

export default function Footer() {
  return (
    <footer className="bg-primary-800 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#hero" className="flex items-center gap-2" aria-label="可可漫画网 首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl text-background-50">可可漫画网</span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              聚合萌系漫画、少女漫画与甜宠漫画的轻量追更门户。软萌角色搭配可爱画风，
              恋爱剧情高甜不虐，每日更新连载与完结作品，陪你一起轻松治愈地追更。
            </p>
            <div className="mt-5 flex gap-3">
              <a href="#subscribe" aria-label="订阅更新" className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50/10 transition-colors hover:bg-background-50/20">
                <i className="ri-mail-line" aria-hidden="true"></i>
              </a>
              <a href="#faq" aria-label="常见问题" className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50/10 transition-colors hover:bg-background-50/20">
                <i className="ri-question-line" aria-hidden="true"></i>
              </a>
              <a href="#hero" aria-label="回到顶部" className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50/10 transition-colors hover:bg-background-50/20">
                <i className="ri-arrow-up-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <nav aria-label="站内导航">
            <h3 className="text-sm font-semibold text-background-50">站内导航</h3>
            <ul className="mt-4 grid grid-cols-1 gap-2.5 text-sm">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="whitespace-nowrap text-background-200 transition-colors hover:text-background-50">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-sm font-semibold text-background-50">热门题材</h3>
            <ul className="mt-4 flex flex-wrap gap-2.5 text-sm">
              {topicLinks.map((t) => (
                <li key={t}>
                  <a
                    href="#featured"
                    className="whitespace-nowrap rounded-full bg-background-50/10 px-3 py-1 text-background-200 transition-colors hover:bg-primary-500 hover:text-background-50"
                  >
                    {t}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-background-50/15 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 可可漫画网 · 让每一段高甜恋爱的漫画都被温柔追更。</p>
          <p className="whitespace-nowrap">联系邮箱：hello@kekemanga.example</p>
        </div>
      </div>
    </footer>
  );
}